import { selectProcedureTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { modelIconNameMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuDynamicIconWithWrapper, type LuDynamicIconWithWrapperProps } from "./LuDynamicIconWithWrapper"
import type { IconsProps, IconType } from "./typings"

interface ProcedureTypeIconProps extends Omit<LuDynamicIconWithWrapperProps, "color" | "icon" | "fallback"> {
	procedureTypeId: string
}

export const ProcedureTypeIcon = memo<ProcedureTypeIconProps>((props) => {
	const { ref, procedureTypeId, background = true, ...rest } = props

	const procedureType = useAppSelector(selectProcedureTypeById(procedureTypeId))

	return (
		<LuDynamicIconWithWrapper
			ref={ref}
			color={procedureType?.color}
			icon={(procedureType?.icon ?? modelIconNameMapping.procedureType) as IconType}
			background={background}
			{...rest}
		/>
	)
})
ProcedureTypeIcon.displayName = "ProcedureTypeIcon"

interface ProcedureTypeIconsProps extends IconsProps {
	procedureTypeIds: string[]
}

export const ProcedureTypeIcons = memo<ProcedureTypeIconsProps>((props) => {
	const { ref, className, procedureTypeIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{procedureTypeIds.slice(0, max ?? procedureTypeIds.length).map((procedureTypeId) => (
				<ProcedureTypeIcon procedureTypeId={procedureTypeId} key={procedureTypeId} />
			))}
		</span>
	)
})
ProcedureTypeIcons.displayName = "ProcedureTypeIcons"
